import React, { Suspense, useEffect } from "react";
import { Redirect, Switch, useHistory } from "react-router-dom";
import { LayoutSplashScreen, ContentRoute } from "../_metronic/layout";
import RoleListPage from "./pages/user_role_management/RoleListPage";
import RoleFormPage from "./pages/user_role_management/RoleFormPage";
import Appointment from "./pages/appointments/Appointment";
import MenuManagement from "./pages/menu_management/MenuManagement";
// import Dashboard from "./pages/dashboard/Dashboard";
import ReportUser from "./pages/report/ReportUser";
import ReportAppoint from "./pages/report/ReportAppoint";
import PackagePromotion from "./pages/marketing_management/package_promotion/PackagePromotion";
import NewsEvents from "./pages/marketing_management/news_events/NewsEvents";
import Broad from "./pages/marketing_management/broadcast_message/Broad";
import UserManagement from "./pages/setting_management/user_management/UserManagement";
import UserMobileManagement from "./pages/setting_management/user_mobile_management/UserMobileManagement";
import Logout from "./pages/auth/Logout";
import PaymentManagement from "./pages/payment_management/PaymentManagement";
import EmergencyManagement from "./pages/emergency/EmergencyManagement";
import AssignDoctor from "./pages/setting_management/assign_doctor/AssignDoctor";
import QueueManagement from "./pages/queue_management/queue_manage/QueueManagement";
import ServiceManage from "./pages/marketing_management/services_manage/ServiceManage";
import HomeBanner from "./pages/marketing_management/home_banner/HomeBanner";
import ForMedicineManage from "./pages/queue_management/medicine_manage/ForMedicineManage";
import AssignBuildSetting from "./pages/setting_management/assign_build/AssignBuildSetting";
import EmergencySetting from "./pages/setting_management/emergency_setting/EmergencySetting";
import ContactSetting from "./pages/setting_management/contact_setting/ContactSetting";
import TextSetting from "./pages/setting_management/text_setting/TextSetting";
import { useSelector } from "react-redux";

export default function BasePage() {
    const history = useHistory();

    // global redux state
    const { redirectRootMenu, menuPermission } = useSelector(state => {
        const { redirectRootMenu, menuPermission } = state.menu;
        return {
            redirectRootMenu,
            menuPermission,
        };
    });

    useEffect(() => {
        const thisMenuPermission = menuPermission?.find(menu => menu?.path === window.location.pathname)?.permission;
        if (thisMenuPermission && !thisMenuPermission?.view) {
            history.replace("/");
        }
    }, [history, menuPermission]);

    return (
        <Suspense fallback={<LayoutSplashScreen />}>
            <Switch>
                {/* start redirect */}
                <Redirect exact from="/" to={redirectRootMenu} />
                {/* end redirect */}

                {/* New HCH */}
                {/* <ContentRoute exact path="/dashboard" component={Dashboard} /> */}

                <ContentRoute exact path="/appointments" component={Appointment} />

                <ContentRoute exact path="/maketing-management/package-promotions" component={PackagePromotion} />
                <ContentRoute exact path="/maketing-management/news-events" component={NewsEvents} />
                <ContentRoute exact path="/maketing-management/service" component={ServiceManage} />
                <ContentRoute exact path="/maketing-management/broadcast-message" component={Broad} />
                <ContentRoute exact path="/maketing-management/home-banner" component={HomeBanner} />

                <ContentRoute exact path="/report/user" component={ReportUser} />
                <ContentRoute exact path="/report/appointment" component={ReportAppoint} />

                <ContentRoute exact path="/setting/assign-doctor" component={AssignDoctor} />
                <ContentRoute exact path="/setting/assign-building" component={AssignBuildSetting} />
                <ContentRoute exact path="/setting/emergency-setting" component={EmergencySetting} />
                <ContentRoute exact path="/setting/contact-setting" component={ContactSetting} />
                <ContentRoute exact path="/setting/text-setting" component={TextSetting} />
                <ContentRoute exact path="/setting/user_management" component={UserManagement} />
                <ContentRoute exact path="/setting/user_mobile_management" component={UserMobileManagement} />

                <ContentRoute exact path="/payment/payment-management" component={PaymentManagement} />

                <ContentRoute exact path="/emergency" component={EmergencyManagement} />

                <ContentRoute exact path="/queue-managment/queue-for-doctor" component={QueueManagement} />
                <ContentRoute exact path="/queue-managment/queue-for-medicine" component={ForMedicineManage} />

                <ContentRoute exact path="/user_role_management/list_user_management" component={UserManagement} />
                <ContentRoute exact path="/user_role_management/role_list" component={RoleListPage} />
                <ContentRoute exact path="/user_role_management/role_form" component={RoleFormPage} />
                <ContentRoute exact path="/user_role_management/role_form/:id" component={RoleFormPage} />

                <ContentRoute exact path="/logout" component={Logout} />

                <ContentRoute exact path="/menu_management" component={MenuManagement} />
            </Switch>
        </Suspense>
    );
}
